import { createContext, useContext } from "react";

import type { BrandRouter } from "./brandRouter";
import type { DemoBrandStore } from "./DemoBrandStore";

export interface BrandWizardContextValue {
  brandStore: DemoBrandStore;
  router: BrandRouter;
  onSubmit?: () => Promise<boolean | string>;
}

const BrandWizardContext = createContext<BrandWizardContextValue | null>(null);

export const useBrandWizardContext = () => {
  const context = useContext(BrandWizardContext);
  if (!context) {
    throw new Error(
      "useBrandWizardContext must be used within BrandWizardProvider"
    );
  }
  return context;
};

export const BrandWizardProvider = BrandWizardContext.Provider;
